export const ACCOUNTS = ['997', '998'];
export const ACCOUNTS_NAME = ['Rent', 'Floor Walking'];
